module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-avatar-03-b8206c269368f9755aeadbf176034f05.png";